"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorshipSchema = void 0;
exports.AuthorshipSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/authorship.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Authorship",
    "description": "Defines authorship for content, allowing editors to associate multiple authors as either text entries or profiles.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:authorship"
            ]
        },
        "authors": {
            "description": "List of authors associated with the content. Each author can be represented as text, or a profile reference.",
            "type": "array",
            "items": {
                "oneOf": [
                    {
                        "type": "object",
                        "description": "Text-based entry for the author’s name, used when no profile is available.",
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    },
                    {
                        "type": "object",
                        "description": "Dedicated author profile, allowing for detailed information to be associated with the author.",
                        "$ref": "https://www.redbull.com/schemas/reference/content/author-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "description": "A person profile, providing the possibility to link athletes or artists that sometimes also write content on the platform.",
                        "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                    }
                ]
            }
        }
    },
    "required": [
        "authors",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yc2hpcC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2F1dGhvcnNoaXAuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0JBQWdCLEdBQUc7SUFDOUIsS0FBSyxFQUFFLG1FQUFtRTtJQUMxRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxZQUFZO0lBQ3JCLGFBQWEsRUFBRSxvSEFBb0g7SUFDbkksTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sdUJBQXVCO2FBQ3hCO1NBQ0Y7UUFDRCxTQUFTLEVBQUU7WUFDVCxhQUFhLEVBQUUsOEdBQThHO1lBQzdILE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE9BQU8sRUFBRTtvQkFDUDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsYUFBYSxFQUFFLDRFQUE0RTt3QkFDM0YsTUFBTSxFQUFFLDZEQUE2RDtxQkFDdEU7b0JBQ0Q7d0JBQ0UsTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLGFBQWEsRUFBRSwrRkFBK0Y7d0JBQzlHLE1BQU0sRUFBRSwrRUFBK0U7cUJBQ3hGO29CQUNEO3dCQUNFLE1BQU0sRUFBRSxRQUFRO3dCQUNoQixhQUFhLEVBQUUsNEhBQTRIO3dCQUMzSSxNQUFNLEVBQUUsK0VBQStFO3FCQUN4RjtpQkFDRjthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFNBQVM7UUFDVCxNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=